import React from 'react';
import './OrbFooter.css';

const OrbFooter = ({ index }) => {
  return (
    <div className={`orb-footer orb-footer-${index + 1}`}></div>
  );
};

export default OrbFooter;
